export default __webpack_public_path__ + "35908d52f92465dcd0e1a2f64fdb4437.png";